/**
 * Tenant/Organization related types and constants
 */

export interface SelectOption {
  value: string;
  label: string;
}

export const COMPANY_SIZE_OPTIONS: SelectOption[] = [
  { value: 'solo', label: 'Just me' },
  { value: '2-10', label: '2–10 people' },
  { value: '11-50', label: '11–50 people' },
  { value: '51-200', label: '51–200 people' },
  { value: '201-1000', label: '201–1,000 people' },
  { value: '1000+', label: '1,000+ people' },
];

export const INDUSTRY_OPTIONS: SelectOption[] = [
  { value: 'ott', label: 'OTT / Streaming' },
  { value: 'broadcast', label: 'Broadcast / Television' },
  { value: 'sports', label: 'Sports Media' },
  { value: 'news', label: 'News & Publishing' },
  { value: 'film', label: 'Film & Entertainment' },
  { value: 'education', label: 'Education' },
  { value: 'enterprise', label: 'Enterprise / Corporate' },
  { value: 'other', label: 'Other' },
];

export const USE_CASE_OPTIONS: SelectOption[] = [
  { value: 'live-vod', label: 'Live to VOD automation' },
  { value: 'ai-meta', label: 'AI metadata & subtitles' },
  { value: 'cdn', label: 'Multi-CDN delivery' },
  { value: 'migration', label: 'Content migration' },
  { value: 'social', label: 'Social media publishing' },
  { value: 'custom', label: 'Custom workflow automation' },
];
